import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sign-in-callback',
    templateUrl: './sign-in-callback.component.html',
    styleUrls: ['./sign-in-callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignInCallbackComponent {
}
